/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Team_Views_ShareInputs */



/**
* | output |
* | --- |
* | "Share saved views with the team" |
*
* @param {Perm_Team_Views_ShareInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_team_views_share = /** @type {((inputs?: Perm_Team_Views_ShareInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Team_Views_ShareInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Делиться сохранёнными фильтрами с командой")
	return /** @type {LocalizedString} */ ("Share saved views with the team")
});